<script setup lang="ts">
  import { ref } from 'vue';
  import { DatePicker, IconImage } from '@/shared/ui';
  import CalendarIcon from '@/shared/assets/icons/CalendarIcon.svg';
  import { formatDateToPtBR } from '@/shared/lib';

  defineProps<{
    triggerTestId: string;
  }>();

  const date = defineModel<Date | null>({ required: true });
  const isOpen = ref(false);
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <h4 class="text-sm font-medium text-gray-07">
      Data
    </h4>
    <button
      type="button"
      :data-testid="triggerTestId"
      class="flex h-11 w-full min-w-56 items-center gap-2 rounded-lg border border-gray-02 bg-white-01 px-3 font-medium text-gray-03 focus:border-(--theme-secondary-ink) focus:outline-none"
      @click="isOpen = true"
    >
      <IconImage
        :src="CalendarIcon"
        alt="Calendário"
        class="h-5 w-5 shrink-0"
      />
      <span class="truncate text-left text-sm">
        {{ date ? formatDateToPtBR(date) : 'Selecione uma data' }}
      </span>
    </button>
    <DatePicker
      v-model:selected-date="date"
      v-model:is-open="isOpen"
      :default-to-today="false"
      @apply="isOpen = false"
      @cancel="isOpen = false"
    />
  </div>
</template>
